import { defaultTechAgentName } from 'constants/general';
import { clientAgentId, mockAgentId, techAgentId } from 'constants/history';
import { AgentData } from 'interfaces/AgentData';
import { Action } from 'redux';
import { staticUrl } from 'utils/dom';

import { AgentActionType, ReceiveAgentAction, ReceiveAgentsAction } from './agents.actions';

const initialState = {
    [techAgentId]: {
        id: techAgentId,
        name: defaultTechAgentName,
    },
    [clientAgentId]: {
        id: clientAgentId,
        name: 'Вы',
    },
    [mockAgentId]: {
        id: mockAgentId,
        name: 'Светлана',
        avatar: staticUrl('img/operator.png'),
    },
} as { [agentId: string]: AgentData };

export const agentsReducer = (
    state = initialState,
    action: Action<AgentActionType>,
): typeof initialState => {
    switch (action.type) {
        case AgentActionType.ReceiveAgent:
            const agent = (action as ReceiveAgentAction).payload;
            return { ...state, [agent.id]: agent };

        case AgentActionType.ReceiveAgents:
            const agents = (action as ReceiveAgentsAction).payload;
            return { ...state, ...agents };

        default:
            return state;
    }
};
